<template>
    <div class="row">
        <div class="col-sm-12 mb-3" >
            <div class="d-flex flex-column gap-3 text-center align-items-center">
	            <i class="bi w-auto h-auto fs-large bi-shield-shaded"></i>
                <h3 class="fw-semi-bold m-0">Two Factor Authentication QR Code</h3>
                <p class="text-secondary m-0">Scan the code below with your Authenticator App to link it.</p>
            </div>
        </div>

        <div class="col-12 d-flex flex-column justify-content-center align-items-center">
	        <div class="text-center" ref="viewQRCodeBlock">

		        <div class="mb-4">
			        <div v-html="twoFactorSetupSvg"></div>
		        </div>

		        <p class="text-center text-muted my-1">or enter the setup key manually</p>
		        <div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken my-3">
			        <input v-model="twoFactorSetupCode"  type="text" id="setup_key" name="setup_key" class="form-control m-0 border-0 fs-5 p-0 lh-fixed text-center" readonly >
			        <label for="setup_key" v-tooltip="'Copy to clipboard'">
				        <i class="me-3 dd-icon bi bi-copy" @click="helper.copyText(twoFactorSetupCode)"></i>
			        </label>
		        </div>
	        </div>
            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center ">
                <button class="btn btn-dark rounded-pill py-2 px-3" @click="close">Close</button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { watch, ref, onMounted } from "vue";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";
import { useToast } from "@/composables/useToast.js";

const emits = defineEmits(['closeViewQRCode']);

const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();

const viewQRCodeBlock = ref(null);

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

onMounted(async () => {
	await getTwoFAQRCode();
});

const twoFAQRCodes = ref({});
const twoFactorSetupSvg = ref(null);
const twoFactorSetupCode = ref(null);

const getTwoFAQRCode = async () => {
	try {
	helper.loaderOn(viewQRCodeBlock.value);

	let qrResponse = await auth.twoFactorQrCode();
	if(qrResponse.response.status === 200) {
		twoFAQRCodes.value = qrResponse.data;
		twoFactorSetupSvg.value = qrResponse.svg;
		twoFactorSetupCode.value = qrResponse.code;
	}
	helper.loaderOff(viewQRCodeBlock.value);
	} catch (error) {
		helper.loaderOff(viewQRCodeBlock.value);
	}

}

const close = async () => {
	emits('closeViewQRCode');
}

defineExpose({
    close
});
</script>
